import React from 'react';
import Button from '@mui/material/Button';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { useTranslation } from 'react-i18next';
import { tokens as c } from '../../theme';
import { calmCaps } from './tableUtils';

/**
 * "← Back" at the top of a detail or form page, as BookingDetails draws it
 * (an orange text button with an arrow; the arrow turns for right-to-left).
 * Use instead of components/GoBackButton (old colours and "<<-").
 *
 *   <BackButton onClick={() => navigate('/users/0', { state: { pageNo } })} />
 */
export default function BackButton({ onClick, label, sx }) {
  const { t, i18n } = useTranslation();
  const rtl = i18n.dir() === 'rtl';
  const Icon = rtl ? ArrowForwardRoundedIcon : ArrowBackRoundedIcon;
  return (
    <Button variant="text" startIcon={<Icon />} onClick={onClick} sx={{ color: c.ACCENT_TEXT, marginInlineStart: -1, alignSelf: 'flex-start', ...(sx || {}) }}>
      {label || calmCaps(t('go_back', { defaultValue: 'Back' }))}
    </Button>
  );
}
